import React, { useMemo } from "react";
import "./styles.css";
import Text from "../typography/text";
import Divider from "../divider/divider";
import moment from "moment";
import { colors } from "../../theme/colors";
import dayjs from "dayjs";

const ProgressBox = ({ item }) => {
  const sumApplied = item?.Commissions?.reduce(
    (sum, commItem) => sum + commItem.Received,
    0,
  );

  const progressBarWidth = (sumApplied / item?.Price) * 100;

  const productGroupName = item.Commissions?.[0]?.ProductGroupName || null;
  const distributorName =
    item?.DistributorName || item.Commissions?.[0]?.DistributorName || "-";

  return (
    <div className="progress-box-parent-container">
      <div className="progress-box-top-container">
        <div
          className="progress-box-progress-bar"
          style={{
            width: `${progressBarWidth}%`,
            backgroundColor: colors["successColor"],
          }}
        ></div>
      </div>
      <div className="progress-bar-content-container">
        <div className="progress-bar-content-top">
          <div style={{ display: "flex", gap: "32px" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "8px",
              }}
            >
              <Text variant="tinyText" color="lightText">
                Distributor Name
              </Text>
              <Text color="darkText">{distributorName}</Text>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "8px",
              }}
            >
              <Text variant="tinyText" color="lightText">
                Product Code
              </Text>
              <Text color="darkText">{item?.ProductCode}</Text>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "8px",
              }}
            >
              <Text variant="tinyText" color="lightText">
                TissueID
              </Text>
              <Text color="darkText">{item?.TissueID ?? ""}</Text>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "8px",
              }}
            >
              <Text variant="tinyText" color="lightText">
                Product Group Name
              </Text>
              <Text color="darkText">{productGroupName}</Text>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "32px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "8px",
              }}
            >
              <Text variant="tinyText" color="lightText">
                Dist %
              </Text>
              <Text color="darkText">{item?.DistPercentage} %</Text>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "8px",
              }}
            >
              <Text variant="tinyText" color="lightText">
                Applied/Paid
              </Text>
              <Text color="darkText">${sumApplied}</Text>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "8px",
              }}
            >
              <Text variant="tinyText" color="lightText">
                Cost
              </Text>
              <Text color="darkText">${item?.Price}</Text>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "8px",
              }}
            >
              <Text variant="tinyText" color="lightText">
                Balance
              </Text>
              <Text color="darkText">${item?.Balance}</Text>
            </div>
          </div>
        </div>
        <Divider borderStyle="dotted" />
        {item?.Commissions?.map((itemComm) => {
          return (
            <div
              className="progress-box-content-middle"
              key={
                itemComm?.CommissionID ||
                itemComm?.ID ||
                `${itemComm?.DateApplied || "date"}-${itemComm?.Received || 0}`
              }
            >
              <div className="progress-box-content-middle-section">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "32px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "8px",
                    }}
                  >
                    <Text variant="tinyText" color="lightText">
                      Date Applied
                    </Text>
                    <Text color="darkText">
                      {moment(itemComm?.DateApplied).format("MMMM DD, YYYY")}
                    </Text>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "8px",
                    }}
                  >
                    <Text variant="tinyText" color="lightText">
                      Statement Month
                    </Text>
                    <Text color="darkText">
                      {itemComm?.StatementMonth ?? itemComm?.StatementMonthYear}
                    </Text>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "32px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "8px",
                    }}
                  >
                    <Text variant="tinyText" color="lightText">
                      Applied/Paid
                    </Text>
                    <Text color="darkText">
                      ${Number(itemComm?.Received).toFixed(2)}
                    </Text>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "8px",
                    }}
                  >
                    <Text variant="tinyText" color="lightText">
                      C. Recd
                    </Text>
                    <Text color="darkText">
                      ${Number(itemComm?.CommissionReceived).toFixed(2)}
                    </Text>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "8px",
                    }}
                  >
                    <Text variant="tinyText" color="lightText">
                      C. Due
                    </Text>
                    <Text color="darkText">
                      ${Number(itemComm?.CommissionDue).toFixed(2)}
                    </Text>
                  </div>
                </div>
              </div>
              <Divider borderStyle="dotted" />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressBox;
